/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function SelectionAll(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M104,40a8.00008,8.00008,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8.00008,8.00008,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16.01833,16.01833,0,0,0,208,32Zm8,72a8.00008,8.00008,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8.00008,8.00008,0,0,0,216,104Zm0,72a8.00008,8.00008,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16.01833,16.01833,0,0,0,16-16V184A8.00008,8.00008,0,0,0,216,176ZM40,152a8.00008,8.00008,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8.00008,8.00008,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16.01833,16.01833,0,0,0,16,16H72a8,8,0,0,0,0-16ZM40,80a8.00008,8.00008,0,0,0,8-8V48H72a8,8,0,0,0,0-16H48A16.01833,16.01833,0,0,0,32,48V72A8.00008,8.00008,0,0,0,40,80ZM176,184H80a8.00008,8.00008,0,0,1-8-8V80a8.00008,8.00008,0,0,1,8-8h96a8.00008,8.00008,0,0,1,8,8v96A8.00008,8.00008,0,0,1,176,184Z" />
    </Svg>
  );
}

export default SelectionAll;
